import React from "react";
import { Link } from "react-router-dom";
import { FileText, ShieldCheck, Mail, ChevronRight } from "lucide-react";
import { ROUTES } from "../routes.js";
import { APP_VERSION } from "../version.js";

export function AppFooter(): React.ReactElement {
  return (
    <footer
      data-testid="app-footer"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        padding: "24px 0 12px 0",
        marginTop: "auto",
        boxSizing: "border-box",
      }}
    >
      {/* Grouped Menu Card */}
      <div
        style={{
          backgroundColor: "var(--color-paper)",
          borderRadius: "var(--radius-button)",
          boxShadow: "var(--shadow-card)",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Row 1: Terms */}
        <Link
          to={ROUTES.TERMS}
          data-testid="footer-terms-link"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "14px 16px",
            textDecoration: "none",
            color: "var(--color-graphite)",
            transition: "background-color 0.15s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--color-canvas)")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "10px",
                backgroundColor: "var(--color-canvas)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "var(--color-slate)",
              }}
            >
              <FileText size={16} strokeWidth={1.75} />
            </div>
            <span style={{ fontSize: "14px", fontWeight: 500 }}>Условия использования</span>
          </div>
          <ChevronRight size={16} color="var(--color-slate)" opacity={0.6} />
        </Link>

        <div style={{ height: "1px", backgroundColor: "var(--color-frost-border)", margin: "0 16px" }} />

        {/* Row 2: Privacy */}
        <Link
          to={ROUTES.PRIVACY}
          data-testid="footer-privacy-link"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "14px 16px",
            textDecoration: "none",
            color: "var(--color-graphite)",
            transition: "background-color 0.15s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--color-canvas)")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "10px",
                backgroundColor: "var(--color-canvas)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "var(--color-slate)",
              }}
            >
              <ShieldCheck size={16} strokeWidth={1.75} />
            </div>
            <span style={{ fontSize: "14px", fontWeight: 500 }}>Конфиденциальность</span>
          </div>
          <ChevronRight size={16} color="var(--color-slate)" opacity={0.6} />
        </Link>

        <div style={{ height: "1px", backgroundColor: "var(--color-frost-border)", margin: "0 16px" }} />

        {/* Row 3: Support */}
        <a
          href="mailto:corgiwork@proton.me"
          data-testid="footer-support-link"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "14px 16px",
            textDecoration: "none",
            color: "var(--color-graphite)",
            transition: "background-color 0.15s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--color-canvas)")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "10px",
                backgroundColor: "var(--color-canvas)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "var(--color-slate)",
              }}
            >
              <Mail size={16} strokeWidth={1.75} />
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ fontSize: "14px", fontWeight: 500 }}>Поддержка</span>
              <span style={{ fontSize: "12px", color: "var(--color-slate)", fontWeight: 400 }}>
                corgiwork@proton.me
              </span>
            </div>
          </div>
          <ChevronRight size={16} color="var(--color-slate)" opacity={0.6} />
        </a>
      </div>

      {/* App Version */}
      <div
        data-testid="footer-version"
        style={{
          textAlign: "center",
          fontSize: "12px",
          color: "var(--color-slate)",
          opacity: 0.6,
          userSelect: "none",
          padding: "4px 0",
        }}
      >
        Версия: {APP_VERSION}
      </div>
    </footer>
  );
}

export default AppFooter;
